import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import DriveThruAffiliateHeader from "../../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-crows-foot.webp"
            alt="Crow's Foot"
          />
        </p>
        <strong>
          A cramped neighborhood of multi-level streets, ruled by gangs.
        </strong>{" "}
        <em>
          Crow’s Foot is a <strong>crossroads</strong>, merging many qualities
          of its neighboring districts: the illict vices of Silkshore, the labor
          and trade of the Docks, the poverty of Charhollow, and the classic
          architecture of Charterhall. The district is a{" "}
          <strong>patchwork</strong>, both held together and threatened to be
          torn apart by the menagerie of <strong>competing street gangs</strong>{" "}
          and <strong>Bluecoat squads</strong> that claim every avenue and
          corner as territory in an endless <strong>turf war</strong>.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-crows-foot.webp"
          alt="Crow's Foot"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Dockers filing to and from work. Minks
                plying their trade on the corners. A squad of Bluecoats shaking
                down a shopkeep for a bribe. Rival gangs calling challenges to
                each other across the rooftops. A fine coach carrying a noble
                seeking illicit wares.
                <br />
                <strong>Streets:</strong> Multi-level, cramped, dark, foggy. Ash
                Way, Cinder Street, Rye Street, Candle Street, Hulliver Lane.
                <br />
                <strong>Buildings:</strong> Flophouses, inns, old manors chopped
                into apartments, traditional stone houses. Smiths, taverns,
                brothels, and butchers.
                <br />
                <strong>Factions.</strong>
                <ul>
                  <li>1. The Crows</li>
                  <li>2. Red Sashes</li>
                  <li>3. The Lampblacks</li>
                  <li>4. Bluecoats</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-crowsfoot.webp"
                  alt="Crow's Foot district traits"
                />
                <br />
                <br />
                <em>
                  Years of murder have made this the most haunted district.
                  Angry ghosts crave bloodshed here. You may take a Devil’s
                  Bargain for +1d for violent action, but the ghost will lash
                  out, too.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Crow&apos;s Foot Locations</h1>
        <strong>
          <u>Crow&apos;s Nest</u>
        </strong>
        : An ancient tower from before the cataclysm that has been a ritual
        sanctum, an astronomer’s laboratory, and a Bluecoat watch post—before
        its current role as the headquarters of the district’s chief gang, the
        Crows.
        <br />
        <br />
        <strong>
          <u>Red Sash Sword Academy</u>
        </strong>
        : This large mansion has been converted into a training school for the
        Falling Star style of Iruvian sword play. The Red Sashes, an Iruvian
        gang who run several luxury drug dens in the district, claim it as their
        HQ and cover operation for their illicit operations.
        <br />
        <br />
        <strong>
          <u>Strathmill House</u>
        </strong>
        : The lost children and <strong>unwanted orphans</strong> of Crow’s Foot
        inevitably pass through the halls of Strathmill House in the{" "}
        <strong>Bagley</strong> area. Some are cared for and trained for jobs at
        the docks or the workhouses of <strong>Coalridge</strong>. Others are
        quietly instructed in the arts of the{" "}
        <strong>lookouts and runners</strong> used by the gangs of the
        district—all for a small fee to Strathmill House, of course.
        <br />
        <br />
        <strong>
          <u>Tangletown</u>
        </strong>
        : Hundreds of years ago, one of the massive leviathan hunter ships was
        partially sunk in the river. Since then, it’s collected an attendant
        flotilla of tiny watercraft, all lashed together into a floating
        neighborhood. Tangletown is considered neutral ground among the street
        gangs of Crow’s Foot, and no violence is allowed there.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_CrowsFoot = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Blades in the Dark"
                  logo={bladesLogo}
                  productUrl="https://www.drivethrurpg.com/en/product/170689/blades-in-the-dark?affiliate_id=844642"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_CrowsFoot;
